import { ApplicationConfig, provideZonelessChangeDetection, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DatePipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { successToastInterceptor } from './core/interceptors/success-toast.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { responseInterceptor } from './core/interceptors/response.interceptor';
import { AuthService } from './core/services/auth.service';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        tokenInterceptor,
        loadingInterceptor,
        errorInterceptor,
        successToastInterceptor,
        responseInterceptor,
        ...environment.backendInterceptors,
      ]),
    ),
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const auth = inject(AuthService);
        return () => firstValueFrom(auth.tryRestoreSession());
      },
      multi: true,
    },
  ],
};
